import Link from "next/link";
import { getHref, toWebp } from "../../utils/common";
import { Image } from "react-bootstrap";
import { useEffect, useState } from "react";
import useDevice from "../../hooks/useDevice";

let baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

const SubMenu = ({
	activeMenuTab,
	menu,
	menuIndex,
	getActiveData,
	handleMenuClick,
	getActiveClass,
	toggleIsMore,
	isMore,
}) => {
	const { deviceType, screenHeight } = useDevice();
	const subMenuList = menu.submenu;

	const activeData = getActiveData(subMenuList)

	const [activeMenuData, setActiveMenuData] = useState(activeData);

	const testimonialInfo =
		activeMenuData?.Ref_testimonial?.testimonials?.data?.[0]?.attributes ||
		{};
	const authorInfo = testimonialInfo?.AutherPosition?.split("of");

	useEffect(() => {
		setActiveMenuData(getActiveData(subMenuList));
	}, [activeMenuTab]);

	return (
		<div
			className="right-menu-main pt-3"
			onMouseLeave={() => setActiveMenuData(getActiveData(subMenuList))}
		>
			{/* seemore menu d-block for normal common layout */}
			<div className={`d-${!isMore ? "block" : "none"} h-100`}>
				<div className={`row h-100`}>
					<div className="col-lg-5 col-xl-6 col-md-6">
						<div className="row">
							{subMenuList
								?.slice(
									0,
									screenHeight <= 768 && deviceType != "iPad"
										? 8
										: 10
								)
								.map((element, i) => {
									const submenuImage = toWebp(
										element?.image?.data?.attributes?.url
									);
									return (
										<div className="col-lg-12" key={i}>
											<div className="sub-menu-content">
												<Link
													href={
														getHref(element.href) ||
														"#"
													}
													onClick={(e) => {
														setActiveMenuData(
															element
														);
														if (
															[
																null,
																"",
																"#",
															].includes(
																element.href
															)
														) {
															e.preventDefault();
															e.stopPropagation();
														} else {
															handleMenuClick(
																menuIndex,
																element
															);
														}
													}}
													onMouseEnter={() =>
														setActiveMenuData(
															element
														)
													}
													className={getActiveClass(
														element.href
													)}
													aria-label={element.title}
												>
													{element?.image.data && (
														<Image
															src={
																element?.image
																	.data
																	? `${baseUrl}${submenuImage}`
																	: null
															}
															alt={
																element?.image
																	.data
																	? `${element?.image.data?.attributes.alternativeText}`
																	: null
															}
														/>
													)}
													<p className="sub-menu-title">
														{element.title}
													</p>
												</Link>
											</div>
										</div>
									);
								})}
							{subMenuList.length >
								(screenHeight <= 768 && deviceType != "iPad"
									? 8
									: 10) && (
									<Link
										href={"/"}
										onClick={(e) => {
											e.preventDefault(),
												e.stopPropagation(),
												toggleIsMore();
										}}
										className="seemore-sublink"
									>
										See More
									</Link>
								)}
						</div>
					</div>

					<div className="col-lg-7 col-xl-6 col-md-6 h-100">
						<div className="card-reviews">
							{/* on hover need to show */}
							<div className="sub-menu-new">
								<p className="h3">
									{[null, "", "#"].includes(
										activeMenuData.href
									) ? (
										activeMenuData.title
									) : (
										<Link
											href={
												getHref(activeMenuData.href) ||
												"#"
											}
											onClick={() => {
												handleMenuClick(
													menuIndex,
													activeMenuData
												);
											}}
											aria-label={activeMenuData.title}
										>
											{activeMenuData.title}
										</Link>
									)}
								</p>
								<p>
									{[null, "", "#"].includes(
										activeMenuData.href
									) ? (
										activeMenuData.description
									) : (
										<Link
											href={
												getHref(activeMenuData.href) ||
												"#"
											}
											onClick={() => {
												handleMenuClick(
													menuIndex,
													activeMenuData
												);
											}}
											aria-label={activeMenuData.title}
										>
											{activeMenuData.description}
										</Link>
									)}
								</p>
								{/* menu list if required to show on hover */}
								{activeMenuData.submenu.length > 0 &&
									activeMenuData.submenu.map((ele) =>
										[null, "", "#"].includes(ele.href) ? (
											<span
												key={ele.id}
												className="menu-sublink"
											>
												{ele.title}
											</span>
										) : (
											<Link
												href={ele.href ? ele.href : "#"}
												onClick={(e) => {
													if (
														[
															null,
															"",
															"#",
														].includes(ele.href)
													) {
														e.preventDefault();
														e.stopPropagation();
													} else {
														handleMenuClick(
															menuIndex,
															ele
														);
													}
												}}
												className={`menu-sublink ${getActiveClass(
													ele.href
												)}`}
												key={ele.id}
											>
												{ele.title}
											</Link>
										)
									)}
							</div>

							{/* todo - d-none for no testimonila menu*/}
							{screenHeight <= 768 &&
								deviceType != "iPad" ? null : (
								<div
									className={`testimonial ${Object.keys(testimonialInfo).length > 0
											? ""
											: "d-none"
										}`}
								>
									<div className="stars">
										<span>
											{Array.from({
												length: Math.round(
													testimonialInfo.Rating
												),
											}).map((_, i) => (
												<i key={i}>
													<Image
														src="/images/star-review.svg"
														alt="star"
														loading="lazy"
														width={20}
														height={20}
													></Image>
												</i>
											))}
										</span>
									</div>
									<p className="h3">
										{testimonialInfo.reviewTitle}
									</p>
									<p className="description">
										{testimonialInfo.text}
									</p>
									<p className="author">
										<strong>{authorInfo?.[0]}</strong>
										{authorInfo?.[1]}
									</p>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>

			{/* seemore menu d-block for 3 column layout */}
			<div className={`d-${!isMore ? "none" : "block"}`}>
				<div className={`row h-100`}>
					<div className="col-lg-12 ">
						<div className="sub-menu-content submenu-full-coumnm h-100">
							<div className="top-div">
								<div className="row gx-1">
									{subMenuList
										?.filter(
											(element) =>
												element.title != "All Services"
										)
										.map((element) => {
											return (
												<div
													className="col-lg-4 col-md-4"
													key={element.id}
												>
													<Link
														href={
															getHref(
																element.href
															) || "#"
														}
														onClick={() => {
															if (
																element.href ==
																null
															) {
																e.preventDefault();
																e.stopPropagation();
															} else {
																handleMenuClick(
																	menuIndex,
																	element
																);
															}
															setActiveMenuData(
																element
															);
														}}
														onMouseEnter={() =>
															setActiveMenuData(
																element
															)
														}
														className={getActiveClass(
															element.href
														)}
														aria-label={
															element.title
														}
													>
														<p className="sub-menu-title">
															{element.title}
														</p>
													</Link>
												</div>
											);
										})}
								</div>
							</div>

							<div className="bottom-div">
								<div className="row">
									<div className="col-lg-12">
										<div className="header-menu-message">
											<p className="h3">
												{[null, "", "#"].includes(
													activeMenuData.href
												) ? (
													activeMenuData.title
												) : (
													<Link
														href={
															getHref(
																activeMenuData.href
															) || "#"
														}
														onClick={() => {
															handleMenuClick(
																menuIndex,
																activeMenuData
															);
														}}
														aria-label={
															activeMenuData.title
														}
													>
														{activeMenuData.title}
													</Link>
												)}
											</p>
											<p className="description">
												{[null, "", "#"].includes(
													activeMenuData.href
												) ? (
													activeMenuData.description
												) : (
													<Link
														href={
															getHref(
																activeMenuData.href
															) || "#"
														}
														onClick={() => {
															handleMenuClick(
																menuIndex,
																activeMenuData
															);
														}}
														aria-label={
															activeMenuData.title
														}
													>
														{
															activeMenuData.description
														}
													</Link>
												)}
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SubMenu;
